import React from "react";
import { withStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Typography, Box } from "@material-ui/core";
import  {
  withToastProps,
} from "../../../components/src/withSnackBar.Web";

export type UploadBoxProps = withToastProps & {
  onSelectFile: (Files: FileList) => {};
  onTouched: () => {};
  multiple: boolean;
  classes: any;
  uploadMsg?: string;
  uploadSubMsg?: string;
  acceptedFormat: string;
  uploadimg?: any;
  height?: React.CSSProperties["height"];
};
export class UploadBoxPic extends React.Component<UploadBoxProps> {
  fileInputRef = React.createRef<HTMLInputElement>();

  fileInputClickedForPic() {
    this.props.onTouched();
    this.fileInputRef?.current?.click();
  }

  filesSelectedForPic() {
    if (this.fileInputRef?.current?.files?.length) {
      this.handleFilesForPic(this.fileInputRef?.current?.files);
    }
  }

  handleFilesForPic(files: FileList) {
    if (
      files[0].name.includes(".jpeg") ||
      files[0].name.includes(".PNG") ||
      files[0].name.includes(".JPG") ||
      files[0].name.includes(".JPEG") ||
      files[0].name.includes(".png") ||
      files[0].name.includes(".jpg")
    ) {
      this.props.onSelectFile(files);
    } else {
      this.props.showToast({
        type: "error",
        message: "invalid file type",
      });
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <>
        <Box
          display="flex"
          className={classes.boxOutlineForPic}
          id="boxOutline"
          onClick={this.fileInputClickedForPic.bind(this)}
        >
          <Typography
            style={{
              width: "100%",
            }}
            variant="body1"
            noWrap
            className={classes.boldTextPic}
          >
            {this.props.uploadMsg ? this.props.uploadMsg : ""}
          </Typography>
          <Typography variant="caption">
            {this.props.uploadSubMsg ? this.props.uploadSubMsg : ""}
          </Typography>
        </Box>
        <input
          ref={this.fileInputRef}
          className={classes.fileInputPic}
          id="fileInput"
          type="file"
          accept={this.props.acceptedFormat}
          multiple={this.props.multiple}
          onChange={this.filesSelectedForPic.bind(this)}
        />
      </>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    marginTop: {
      marginTop: theme.spacing(2),
    },
    fileInputPic: {
      display: "none",
    },
    boxOutlineForPic: {
      borderRadius: "0.50rem",
      backgroundColor: "#8F92A1",
      padding: "0.25rem 0",
      cursor: "pointer",
    },

    boldTextPic: {
      color: theme.palette.common.white,
      textAlign: "center",
      cursor: "pointer",
      padding: "0 1rem",
    },
  });

export default withStyles(styles, { withTheme: true })(UploadBoxPic);
